__turbopack_context__.v({
  "drawer": "Basic-module-scss-module__0Dc0Mq__drawer",
  "drawerBackground": "Basic-module-scss-module__0Dc0Mq__drawerBackground",
  "drawerPosition": "Basic-module-scss-module__0Dc0Mq__drawerPosition",
  "drawer_content_position": "Basic-module-scss-module__0Dc0Mq__drawer_content_position",
  "full": "Basic-module-scss-module__0Dc0Mq__full",
  "handle": "Basic-module-scss-module__0Dc0Mq__handle",
  "stretchable": "Basic-module-scss-module__0Dc0Mq__stretchable",
  "stretchable_drawer": "Basic-module-scss-module__0Dc0Mq__stretchable_drawer",
  "top": "Basic-module-scss-module__0Dc0Mq__top",
});
